import React from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { addComment } from '../api'
import { Box, IconButton, InputAdornment, TextField } from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send'

const schema = yup.object().shape({
  comment: yup.string().required('Commentaire est requis.'),
})
const FormComment = ({ record, type, refresh = () => {} }) => {
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      comment: '',
    },
  })
  const onAddComment = async (data) => {
    const payload = {
      ...data,
    }
    await addComment(record.id, type, payload)
    reset()
    refresh()
  }
  return (
    <form onSubmit={handleSubmit(onAddComment)}>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          marginTop: 10,
        }}
      >
        <TextField
          {...register('comment')}
          name="comment"
          fullWidth
          label="Ecrire un commentaire"
          error={errors.comment ? true : false}
          helperText={errors.comment?.message}
          variant="outlined"
          size="medium"
          style={{ flex: 1 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton type="submit" edge="end">
                  <SendIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </form>
  )
}
export default FormComment
